import { Component, Input } from '@angular/core';
import { Customer } from '../../resources/models/customer.model';

@Component({
  templateUrl: './editor-unavailable.component.html',
  styleUrls: ['./editor-unavailable.component.sass'],
})
export class EditorUnavailableComponent {
  @Input() customer: Customer;
}



// WEBPACK FOOTER //
// ./src/app/editor/editor-unavailable/editor-unavailable.component.ts